<template>
  <div class="edit-table">
    <!-- v-if="visible_search" -->
    <!-- :loading="searchLoading" -->
    <!-- :visible="option_searchVisible" -->
    <!-- @searchReset="searchReset" -->
    <!-- @searchChange="searchChange" -->
    <template v-if="visible_search">
      <edit-search
        :loading="searchLoading"
        :columns="searchColumns"
        :search-span="option.searchSpan"
        @searchChange="searchChange"
        @searchReset="searchReset"
      >
        <template v-for="item in searchSlotItems" :slot="item">
          <slot :name="item" />
        </template>
      </edit-search>
    </template>
    <b-overlay :show="getLoading" rounded="sm">
      <div v-if="option_header" class="edit-table-top p-1">
        <div
          style="display: block;width: 200px;height: 30px;position: absolute;z-index: 1000;text-align: left"
        >
          <slot name="headLeftAera" />
        </div>
        <slot name="header" />
        <b-button
          v-if="option_addBtn"
          variant="primary"
          class="btn ml-0-5 mr-0-5"
          size="sm"
          @click="handleAdd()"
        >
          <feather-icon icon="PlusIcon" size="18" />
        </b-button>
        <b-button
          v-if="option_refreshBtn"
          variant="secondary"
          class="btn ml-0-5 mr-0-5"
          size="sm"
          @click="handleRefresh"
        >
          <feather-icon icon="RefreshCcwIcon" size="18" />
        </b-button>
      </div>
      <validation-observer :ref="`simpleRules`">
        <!-- :sticky-header="stickyHeader" -->
        <b-table
          small
          responsive
          :sticky-header="option.stickyHeader"
          :fields="columnsFormat"
          :items="reData"
          :foot-clone="option.summary"
          :bordered="true"
        >
          <template v-slot:cell()="row">
            <template v-if="tableSlotItems.includes(row.field.field)">
              <slot name="table-row" :row="row" />
            </template>

            <template v-else-if="row.field.field === 'snIndex'">
              <div class="rank-base">
                <template>
                  {{ row.index + 1 }}
                </template>
              </div>
            </template>
            <!-- 排名 -->
            <template v-else-if="row.field.field === 'index'">
              <div
                class="rank-base"
                :class="[row.index + 1 <= 3 ? 'rank-third' : 'rank-block']"
              >
                <template>
                  {{ row.index + 1 }}
                </template>
              </div>
            </template>
            <template v-else-if="row.field.field === '_menu'">
              <feather-icon
                v-if="option_viewBtn && !row.item['option_viewBtn']"
                :icon="'SearchIcon'"
                class="text-primary cursor-pointer mr-1"
                size="20"
                @click="handleView(row, row.index)"
              />
              <feather-icon
                v-if="option_editBtn && !row.item['option_editBtn']"
                :icon="isEdit === row.index ? 'SaveIcon' : 'Edit2Icon'"
                class="text-warning cursor-pointer mr-1"
                size="20"
                @click="handleEdit(row, row.index)"
              />

              <feather-icon
                v-if="row.item['option_detailBtn']"
                icon="EyeIcon"
                class="text-success cursor-pointer mr-1"
                size="20"
                @click="row.toggleDetails"
              />
              <feather-icon
                v-if="isEdit === row.index && !row.item.ISNOTSAVEDATA"
                icon="XIcon"
                class="text-danger cursor-pointer"
                size="20"
                @click="handleCancel()"
              />
              <template v-else>
                <feather-icon
                  v-if="option_delBtn && !row.item['option_delBtn']"
                  icon="Trash2Icon"
                  class="text-danger cursor-pointer"
                  size="20"
                  @click="handleDel(row)"
                />
              </template>
              <feather-icon
                v-if="
                  option_historyBtn &&
                    !row.item['historyBtn'] &&
                    isEdit !== row.index &&
                    showHistory
                "
                icon="ClockIcon"
                class="text-primary cursor-pointer mr-1"
                size="20"
                @click="handleHistory(row, row.index)"
              />
              <slot name="menu" :row="row" />
            </template>
            <template v-else>
              <template v-if="option_defaultEdit && !row.field.disabled">
                <validation-provider
                  #default="{ errors }"
                  :name="row.field.label + row.index"
                  :rules="
                    row.field.formOption ? row.field.formOption.rules : ''
                  "
                >
                  <div class="input-box">
                    <element-component
                      key="edit"
                      v-model="
                        data[row.index][
                          row.field.saveField
                            ? row.field.saveField
                            : row.field.field
                        ]
                      "
                      :state="errors.length > 0 ? false : null"
                      :name="
                        option.radioRowNameKey
                          ? row.item[option.radioRowNameKey]
                          : ''
                      "
                      :label="row.field.label"
                      :option="row.field"
                      :disabled="disabled"
                    />
                    <!-- <span class="input-box__errors"><small class="text-danger">{{ errors[0] }}</small></span> -->
                    <span class="input-box__errors"
                      ><small class="text-danger">{{
                        errors[0] ? 'this is required' : ''
                      }}</small></span
                    >
                  </div>
                </validation-provider>
              </template>
              <template v-else-if="isEdit === row.index && !row.field.disabled">
                <validation-provider
                  #default="{ errors }"
                  :name="row.field.label"
                  :rules="
                    row.field.formOption ? row.field.formOption.rules : ''
                  "
                >
                  <div class="input-box" :style="`width: ${row.field.width}px`">
                    <element-component
                      key="edit"
                      v-model="
                        rowData[
                          row.field.type === 'upload'
                            ? row.field.key
                            : row.field.field
                        ]
                      "
                      :state="errors.length > 0 ? false : null"
                      :label="row.field.label"
                      :option="row.field"
                    />
                    <span class="input-box__errors"
                      ><small class="text-danger">{{ errors[0] }}</small></span
                    >
                  </div>
                </validation-provider>
              </template>
              <template v-else>
                <template v-if="row.field.type === 'upload'">
                  <c-upload
                    key="readonly"
                    :value="row.value"
                    size="sm"
                    :limit="10"
                    :readonly="true"
                  />
                </template>
                <template
                  v-else-if="
                    currentEditIndex === row.index &&
                      row.field.field === currentEditField
                  "
                >
                  <validation-observer :ref="`simpleRules${row.index}`">
                    <validation-provider
                      #default="{ errors }"
                      :name="row.field.label"
                      :rules="
                        row.field.formOption ? row.field.formOption.rules : ''
                      "
                    >
                      <element-component
                        key="edit"
                        v-model="
                          rowData[
                            row.field.type === 'upload'
                              ? row.field.key
                              : row.field.field
                          ]
                        "
                        style="width:200px;display: inline-block;"
                        :label="row.field.label"
                        :option="row.field"
                      />
                      <feather-icon
                        icon="SaveIcon"
                        class="text-warning cursor-pointer mr-1 ml-1"
                        size="20"
                        @click="handleEdit(row, row.index)"
                      />
                      <feather-icon
                        icon="XIcon"
                        class="text-danger cursor-pointer"
                        size="20"
                        @click="handleCancel()"
                      />
                      <br />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </validation-observer>
                </template>
                <template v-else>
                  {{ row.value }}
                  <!-- {{ row.item.vacationName }}
                  {{ row.field.offInLieuEdit }}
                  {{ row.offInLieuEdit }} -->
                  <!-- {{ row }} -->
                  <feather-icon
                    v-if="
                      row.field.offInLieuEdit
                        ? row.item.vacationName !== 'Off-In-Lieu'
                        : row.field.edit
                    "
                    style="transform: translateX(3px) translateY(-3px);"
                    class="text-primary cursor-pointer"
                    icon="Edit2Icon"
                    size="18"
                    @click="handleEditClick(row)"
                  />
                </template>
              </template>
            </template>
          </template>
          <template v-if="option.summary" v-slot:foot()="scope" sticky-column>
            <template v-if="scope.field.field === '_menu'">
              {{ '' }}
            </template>
            <template v-else-if="scope.field.salary === true && option.summary">
              {{ getSummaries(reData, scope.field.field) }}
            </template>
            <template v-else-if="scope.field.field !== '_menu'">
              {{ scope.field.footField }}
            </template>
          </template>
          <template v-slot:row-details="row">
            <b-card>
              <slot name="row-details" :row="row" />
            </b-card>
          </template>
        </b-table>
      </validation-observer>
      <template v-if="option_isPagination">
        <c-pagination
          :page="page"
          @change="pageChange"
          @pageSizeChange="pageSizeChange"
        />
      </template>
    </b-overlay>
    <!-- form弹窗 -->
    <template v-for="(item, key) in sidebarShow">
      <c-form
        :key="key"
        :visible="sidebarShow[key]"
        :width="option_drawerWidth"
        :title="sidebarTitle(key)"
        :loading="formLoading"
        :data="rowData"
        :option="option"
        :page-key="key"
        @beforeClose="handleBeforeClose(key)"
        @submit="handleSubmit"
      >
        <slot :name="`${key}Drawer`" />
        <template v-for="slotName in formSlotItems" :slot="slotName">
          <slot :name="slotName" :type="key" />
        </template>
      </c-form>
    </template>
    <c-modal
      :visible="modalShow"
      page-key="delete"
      @close="modalShow = false"
      @modelConfirm="handleModelConfirm"
    />
  </div>
</template>

<script>
import {
  BTable,
  BFormInput,
  BButton,
  BOverlay,
  BPagination,
  BFormSelect,
  BFormGroup,
  BCard,
} from 'bootstrap-vue'
import { deepClone } from '@/util/util'
import CModal from '@/components/crud/modal.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, confirmed, password } from '@validations'
import CPagination from './pagination.vue'
import EditSearch from './search.vue'
import applyApi from '@/api/apply'
// import ElementComponent from '../elementComponent.vue'
import CUpload from '../upload/index.vue'
// import CForm from '../crud/form.vue'

export default {
  name: 'EditTable',
  components: {
    EditSearch,
    BTable,
    BButton,
    CModal,
    ElementComponent: () => import('../elementComponent.vue'),
    CUpload,
    BOverlay,
    CForm: () => import('../crud/form.vue'),
    ValidationProvider,
    ValidationObserver,
    CPagination,
    BCard,
  },
  props: {
    /**
     * 新增功能
     * option.showFoot 用于显示是否有尾部表格
     * 单个列中 footField 用于自定义字段
     * 单个列中 total 用于表示合计
     */
    option: {
      type: Object,
      default: () => {},
    },
    showHistory: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      default: () => {},
    },
    // 弹窗关闭前的回调
    beforeClose: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formDataAll: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columns: this.option.columns || [],
      isEdit: -1,
      rowData: {},
      modalShow: false,
      insideLoading: false,
      formLoading: false,
      searchLoading: false,
      reData: [],
      sidebarShow: {
        add: false,
        edit: false,
        view: false,
      },
      currentEditField: '',
      currentEditIndex: -1,

      // currentPage: 1,
      // totalRows: 1,
      // totalRows: 12,
      // perPage: 5,
      perPage: 10,
      pageOptions: [3, 5, 10],
      // page: {
      //   pageSize: 10,
      //   currentPage: 1,
      //   total: 0,
      // },
      // 规则
      required,
      password,
      email,
      confirmed,
    }
  },
  computed: {
    searchColumns() {
      const temp = []
      this.columns.forEach((item) => {
        if (item.search) {
          temp.push(item)
        }
      })
      return temp
    },
    searchSlotItems() {
      // const slots = this.searchColumns.filter(o => o.searchSlot) || []
      const slots = this.searchColumns
      // console.log(slots, 'slots+++==')
      return slots.map((o) => `${o.field}Search`)
    },
    getLoading() {
      return this.loading || this.insideLoading
    },
    uniqueColumns() {
      const temp = deepClone(this.columns)
      let result = []

      function unique(arr1) {
        const res = new Map()
        return arr1.filter((a) => !res.has(a.field) && res.set(a.field, 1))
      }
      result = unique(temp)
      return result
    },
    columnsFormat() {
      const temp = this.option.columns
      const res = []
      temp.forEach((item) => {
        if (!item.hide) {
          const t = item
          if (item.dictField) {
            t.key = item.dictField
          } else {
            t.key = item.field
          }
          t.class = `${item.class} table-td`
          res.push(t)
        }
      })
      return res
    },
    option_menu() {
      return typeof this.option.menu === 'boolean' ? this.option.menu : true
    },
    option_defaultEdit() {
      return typeof this.option.defaultEdit === 'boolean'
        ? this.option.defaultEdit
        : false
    },
    option_drawerWidth() {
      // return this.option.drawerWidth ? `${this.option.drawerWidth}px` : 'auto'
      return this.option.drawerWidth ? `${this.option.drawerWidth}px` : '500'
    },
    option_drawer() {
      return typeof this.option.drawer === 'boolean'
        ? this.option.drawer
        : false
    },
    option_viewBtn() {
      return typeof this.option.viewBtn === 'boolean'
        ? this.option.viewBtn
        : false
    },
    option_addBtn() {
      return typeof this.option.addBtn === 'boolean' ? this.option.addBtn : true
    },
    option_editBtn() {
      return typeof this.option.editBtn === 'boolean'
        ? this.option.editBtn
        : true
    },
    option_historyBtn() {
      return typeof this.option.option_historyBtn === 'boolean'
        ? this.option.option_historyBtn
        : true
    },
    option_delBtn() {
      return typeof this.option.delBtn === 'boolean' ? this.option.delBtn : true
    },
    option_header() {
      return typeof this.option.header === 'boolean' ? this.option.header : true
    },
    option_refreshBtn() {
      return typeof this.option.refresh === 'boolean'
        ? this.option.refresh
        : true
    },
    option_isPagination() {
      return typeof this.option.isPagination === 'boolean'
        ? this.option.isPagination
        : false
    },
    visible_search() {
      return typeof this.option.search === 'boolean'
        ? this.option.search
        : false
    },
    allColumnKeys() {
      const arr = this.columnsFormat.filter((o) => o.field !== '_menu') || []
      return arr.map((o) => o.field)
    },
    showFoot() {
      return this.option.showFoot
    },
    formSlotItems() {
      const slots =
        this.option.columns.filter((o) => {
          if (o.formOption) {
            if (o.formOption.slot) return o
          }
          return false
        }) || []
      return slots.map((o) => `${o.field}Form`)
    },
    tableSlotItems() {
      const slots = this.option.columns.filter((o) => o.html) || []
      return slots.map((o) => `${o.field}`)
    },
    currentPage() {
      return this.page.currentPage
    },
    pageData() {
      return this.page
    },
  },
  watch: {
    // currentPage() {
    //   console.log(this.currentPage, 'currentPage+++==')
    // },
    data: {
      handler(e) {
        this.reData = e
      },
      immediate: true,
      deep: true,
    },
    rowData(e) {
      this.$emit('update:form', e)
    },
    option: {
      handler(e) {
        this.columns = e.columns
        // 判断menu是否需要渲染
        if (this.option_menu) {
          this.columns.push({
            label: this.$t('_components.btns.menu'),
            field: '_menu',
            class: 'table-td table-td-sm',
          })
        }
      },
    },
  },
  created() {
    // 判断menu是否需要渲染
    if (this.option_menu) {
      this.columns.push({
        label: this.$t('_components.btns.menu'),
        field: '_menu',
        class: 'table-td table-td-sm',
      })
    }
  },
  methods: {
    searchChange(form) {
      this.searchLoading = true
      const done = () => {
        if (this.searchLoading) {
          this.searchLoading = false
        }
      }
      const res = {}
      Object.keys(form).forEach((key) => {
        const item = form[key]
        if (item) {
          res[key] = item
        }
      })
      this.$emit('searchChange', done, res)
    },
    searchReset() {},
    pageChange(e) {
      this.$emit('pageChange', e)
    },
    getSummaries(data, field) {
      let summaries = 0
      if (data && data.length && field) {
        const values = data.map((el) => el[field])
        summaries = values.reduce((v, c) => v + Number(c), 0)
      }
      return summaries
    },
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelCert.${param}`)
    },
    // 获取弹窗标题
    sidebarTitle(key) {
      const defaultLink = '_components.btns.'
      return this.$t(`${defaultLink + key}`) || key
    },
    handleHistory(row) {
      this.$emit('history-change', row)
    },
    // 点击刷新
    handleRefresh() {
      this.$emit('refresh-change')
    },
    // 弹窗关闭前的回调 父组件调用done执行完成
    handleBeforeClose(type) {
      this.formLoading = false
      let isDone = false
      const done = () => {
        if (!isDone) {
          this.sidebarShow[type] = false
          isDone = true
        }
      }
      this.beforeClose(done, type)
    },
    // 表单提交
    handleSubmit(key, data) {
      this.formLoading = true
      const done = () => {
        if (this.formLoading) {
          this.formLoading = false
          this.sidebarShow[key] = false
        }
      }
      this.$emit(`submit-${key}`, done, data)
    },
    // 查看表单
    handleView(row, rowIndex) {
      if (this.option_drawer) {
        this.rowData = deepClone(row.item)
        this.sidebarShow.view = true
      }
    },
    async handleEdit(row, rowIndex) {
      const isEdit =
        this.isEdit === rowIndex || this.currentEditIndex === rowIndex
      if (this.option_drawer) {
        this.rowData = deepClone(row.item)
        this.sidebarShow.edit = true
        return
      }
      console.log('ssssss',isEdit)
      if (isEdit) {
        this.$refs.simpleRules.validate().then(async (success) => {
          console.log('success',success)
          if (success) {
            this.insideLoading = true
            const checkSuccess = await this.checkOtTime(this.rowData)
            console.log('checkSuccess',checkSuccess)
            if (!checkSuccess) {
              this.insideLoading = false
              return
            }

            let isDone = false
            const done = () => {
              if (!isDone) {
                this.isEdit = -1
                this.currentEditField = ''
                this.currentEditIndex = -1
                isDone = true
                this.insideLoading = false
                this.rowData = {}
              }
            }
            const key = this.rowData.id ? 'edit' : 'add'
            this.$emit(
              `submit-${key}`,
              done,
              this.rowData,
              this.currentEditIndex
            )
          }
        })
      } else {
        this.rowData = deepClone(row.item)
        this.isEdit = row.index
      }
    },
    async checkOtTime(row) {
      console.log('checkOtTime',row,this.option)  
      const rowData = row || this.rowData || {}
      if (this.option.tableName !== 'OTApplication') {
        return true
      }

      const staffId =
        this.formDataAll.staffId || this.formDataAll.staffID
      if (!staffId) {
        this.$message.error('Please select staff first')
        return false
      }

      try {
        const res = await applyApi.checkOt({
          staffId,
          number: rowData.number,
          startTime: rowData.startTime,
          endTime: rowData.endTime,
        })
        const result = res.data.data
        const isValid =
          result !== false &&
          (!result || typeof result !== 'object' || result.valid !== false)
        if (!isValid) {
          this.$message.error(res.data.msg || 'The overtime period is invalid')
        }
        return isValid
      } catch (error) {
        return false
      }
    },
    handleEditClick(data) {
      this.currentEditField = data.field.field
      this.currentEditIndex = data.index
      this.rowData = deepClone(data.item)
    },
    handleDel(row) {
      this.rowData = deepClone(row.item)
      this.modalShow = true
    },
    handleCancel() {
      this.isEdit = -1
      this.currentEditField = ''
      this.currentEditIndex = -1
      this.handleRefresh()
    },
    handleModelConfirm() {
      let isDone = false
      this.insideLoading = true
      const done = () => {
        if (!isDone) {
          this.insideLoading = false
          isDone = true
        }
      }
      this.$emit('rowDel', done, this.rowData)
      this.rowData = {}
      this.modalShow = false
    },
    handleAdd() {
      if (this.option_drawer) {
        this.rowData = {}
        this.sidebarShow.add = true
        return
      }
      // 验证
      const lastRow = this.reData[this.reData.length - 1] || {}

      if (lastRow.ISNOTSAVEDATA) {
        return
      }
      const rowCol = {}
      this.columns.forEach((item) => {
        rowCol[item.field] = ''
      })
      rowCol.ISNOTSAVEDATA = true
      this.reData.push(rowCol)
      this.isEdit = this.reData.length - 1
    },
  },
}
</script>

<style lang="scss">
.rank-third {
  color: #fff;
  background: cornflowerblue;
}
.rank-block {
  background: #ccc;
  color: #fff;
}
.rank-base {
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  display: inline-block;
  border-radius: 5px;
}
.table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,
[dir] .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
  background: #fff;
}
.edit-table {
  padding: 10px;
  &-top {
    text-align: right;
  }
  .table-td {
    text-align: center;
    line-height: 50px;
    vertical-align: top;
    &-sm {
      width: 200px;
    }
  }

  .ml-0-5 {
    margin-left: 0.5rem !important;
  }
  .mr-0-5 {
    margin-right: 0.5rem !important;
  }
  .input-box {
    padding-bottom: 4px;
    position: relative;
    &__errors {
      line-height: 20px;
    }
  }
  .table-b-table-default {
    top: -1px !important;
  }
}
</style>
